import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showBNOSearchModal'
            }
        ],
        formActions: [],
        rowActions: [],
        searchFields: [
            {
                name: "kod",
                label: "Kód",
                formSize: 4,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "leiras",
                label: "Leírás",
                formSize: 4,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "fileName",
                label: "Betöltött fájl",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllMDBFile,
                    formatText: function (val) {
                        return val.fileName;
                    },
                    formatOption: function (val) {
                        return val.fileName + ' ' + val.loaded;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'fileName',
                    returnValue: 'fileName',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "archivedOnFrom",
                label: "Archiválás időponttól",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
            {
                name: "archivedOnTo",
                label: "Archiválás időpontig",
                formSize: 4,
                formVisible: true,
                formType: 'date',
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                visibility: false
            },
            {
                name: "kod",
                label: "Kód",
                sort: true,
                visibility: true
            },
            {
                name: "leiras",
                label: "Leírás",
                sort: true,
                visibility: true
            },
            {
                name: "fileName",
                label: "Betöltött fájl",
                sort: true,
                visibility: true
            },
            {
                name: "archivedOn",
                label: "Archiválás ideje",
                sort: true,
                visibility: true,
                slot_name: "datetime_format"
            },
            {
                name: "archivedBy",
                label: "Archiváló",
                sort: true,
                visibility: true,
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                visibility: false,
            },
            {
                name: "createdOn",
                label: "createdOn",
                visibility: false,
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                visibility: false,
            },
            {
                name: "createdBy",
                label: "createdBy",
                visibility: false,
            },
            {
                name: "deleted",
                label: "deleted",
                visibility: false,
            },
            {
                name: "companyId",
                label: "companyId",
                visibility: false,
            }
        ]
    }
}
